import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Authentication components
import Login from './Components/Login/Login';
import Signup from './Components/Signup/Signup';
import { useAuth } from './Contexts/AuthContext/AuthContext';

import AdminLayout from './Interface/Admin-Pages/AdminLayout';
import AdminDashboard from './Interface/Admin-Pages/AdminDashboard';
import AdminAssignments from './Interface/Admin-Pages/AdminAssignments';
import ManageRecords from './Interface/Admin-Pages/ManageRecords';
import VolunteerList from './Interface/Admin-Pages/VolunteerList';
import TaskList from './Interface/Admin-Pages/TaskList';
import AdminProjects from './Interface/Admin-Pages/AdminProjects'; 
import VolunteerDashboard from './Interface/Volunteer-Pages/VolunteerDashboard';
import VolunteerLayout from './Interface/Volunteer-Pages/VolunteerLayout';
import MyTasks from './Interface/Volunteer-Pages/MyTasks';
import VolunteerProjects from './Interface/Volunteer-Pages/VolunteerProjects';
import BadgePage from './Interface/Volunteer-Pages/BadgePage';
import ProjectTasks from './Interface/Volunteer-Pages/ProjectTasks';


// Public pages
import UserLayout from './Interface/Public-Pages/UserLayout';
import LandingPage from './Interface/Public-Pages/LandingPage';
import About from './Interface/Public-Pages/About';
import PublicProjects from './Interface/Public-Pages/PublicProjects';
import DiscussionForum from './Interface/Public-Pages/DiscussionForum';
import Donations from './Interface/Public-Pages/DonationsPage';
import Applicationform from './Interface/Public-Pages/ApplicationForm';
import ApplicationStatus from './Interface/Public-Pages/ApplicationStatus';
import MapView from './Interface/Public-Pages/MapView';

function App() {
  const { userLoggedIn, loading, userRole } = useAuth(); // Removed currentUser since we use userRole
  
  console.log("Auth State:", { userLoggedIn, loading, userRole }); 
  
  if (loading) return <div>Loading...</div>;

  const isAdmin = userRole === 'admin';
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* Main public website */}
      <Route path="/" element={<UserLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<PublicProjects />} />
        <Route path="/forum" element={<DiscussionForum />} />
        <Route path="/donations" element={<Donations />} />
        <Route path="/map" element={<MapView />} />
        <Route path="/application" element={<Applicationform />} />
        <Route path="/application-status" element={<ApplicationStatus />} />
      </Route>
      
      {/* Protected admin routes */}
      <Route 
        path="/admin/*" 
        element={userLoggedIn && isAdmin ? <AdminLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<AdminDashboard />} />
        <Route path="task-approvals" element={<AdminAssignments />} />
        <Route path="manage-records" element={<ManageRecords />} />
        <Route path="manage-records/:tab" element={<ManageRecords />} />
        <Route path="manage-records/projects/:projectId/tasks" element={<TaskList />} />
        <Route path="tasks" element={<TaskList />} />
        <Route path="admin-projects" element={<AdminProjects />} />
        <Route path="volunteers" element={<VolunteerList />} />
      </Route>

      {/* Protected volunteer routes */}
      <Route 
        path="/volunteer/*" 
        element={userLoggedIn && userRole === 'volunteer' ? <VolunteerLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<VolunteerDashboard />} />
        <Route path="badges" element={<BadgePage />} />
        <Route path="projects" element={<VolunteerProjects />} />
        <Route path="projects/:projectId/tasks" element={<ProjectTasks />} />
        <Route path="my-tasks" element={<MyTasks />} />
      </Route>
      
      {/* Root redirect based on user role */}
      <Route 
        path="/" 
        element={
          userLoggedIn ? (
            isAdmin ? (
              <Navigate to="/admin" replace />
            ) : (
              <Navigate to="/volunteer/dashboard" replace />
            )
          ) : (
            <Navigate to="/" replace />
          )
        } 
      />
      
      {/* Catch all redirect */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;